if (!customElements.get('featured-collection-tabs')) {
  customElements.define('featured-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-latest-panel]'));
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), { signal });
        tab.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.activate(target, true);
        }, { signal });
      });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.tabs.findIndex((tab) => tab === event.target || tab.contains(event.target));
        if (index >= 0) this.activate(index);
      }, { signal });
      this.activate(0);
    }

    activate(index, focus = false) {
      this.tabs.forEach((tab, position) => {
        tab.setAttribute('aria-selected', String(position === index));
        tab.tabIndex = position === index ? 0 : -1;
        this.panels[position].hidden = position !== index;
      });
      if (focus) this.tabs[index].focus({ preventScroll: true });
      const panel = this.panels[index];
      requestAnimationFrame(() => {
        panel.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
        // Panels hidden during scroll-reveal initialization must become visible on selection.
        panel.querySelectorAll('.scroll-trigger').forEach((item) => item.classList.add('scroll-trigger--cancel'));
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}